function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var parseResponsiveStyle = function parseResponsiveStyle(_ref) {
  var cache = _ref.cache,
      systemConfig = _ref.systemConfig,
      scale = _ref.scale,
      propValue = _ref.propValue,
      props = _ref.props;
  var styles = {};
  var mediaQueries = cache.media;
  propValue.slice(0, mediaQueries.length).forEach(function (valueAtQuery, i) {
    // e.g. <Box color={[theme => theme.colors.primary, theme => theme.colors.secondary]} />
    var value = typeof valueAtQuery === 'function' ? valueAtQuery(props.theme) : valueAtQuery;
    var media = mediaQueries[i]; // @ts-ignore

    var style = systemConfig(value, scale, props, cache);

    if (!media) {
      styles = _extends({}, styles, style);
    } else {
      var _extends2;

      styles = _extends({}, styles, (_extends2 = {}, _extends2[media] = _extends({}, styles[media], style), _extends2));
    }
  });
  return styles;
};
var parseResponsiveObject = function parseResponsiveObject(_ref2) {
  var cache = _ref2.cache,
      systemConfig = _ref2.systemConfig,
      scale = _ref2.scale,
      propValue = _ref2.propValue,
      props = _ref2.props;
  var breakpoints = cache.breakpoints;
  var styles = {};

  for (var key in propValue) {
    // @ts-ignore
    var breakpoint = breakpoints[key];
    var valueAtQuery = propValue[key]; // e.g.
    // <Box
    //   color={{
    //     [bp.bp320]: t => t.colors.primary,
    //     [bp.bp640]: t => t.colors.secondary
    //   }}
    // />

    var value = typeof valueAtQuery === 'function' ? valueAtQuery(props.theme) : valueAtQuery; // @ts-ignore

    var style = systemConfig(value, scale, props, cache);

    if (!breakpoint) {
      styles = _extends({}, styles, style);
    } else {
      var _extends3;

      var media = createMediaQuery(breakpoint);
      styles = _extends({}, styles, (_extends3 = {}, _extends3[media] = _extends({}, styles[media], style), _extends3));
    }
  }

  return styles;
};

/**
 * Generic "get" function
 * Used with 'noprefix' tokenPrefix value
 */
var get = function get(object, path, defaultValue) {
  if (!object) {
    return defaultValue;
  }

  var route = typeof path === 'string' ? path.split('.') : [path]; // Start with theme, that will get narrowed down

  var result = object;

  for (var p = 0; p < route.length; p++) {
    // For the length of the map, dive deeper into the object
    // and return the property at that depth
    var next = route[p];

    if (result && (typeof next === 'number' || typeof next === 'string')) {
      result = result[next];
    } else {
      result = undefined;
    }
  }

  return result === undefined ? defaultValue : result;
};
/**
 * Requires path to have '$' prefixing the value
 * Used with 'prefix' tokenPrefix value
 */

var prefixGet = function prefixGet(object, path, defaultValue) {
  var result;

  if (typeof path === 'string' && path.startsWith('$')) {
    result = get(object, path.slice(1));
  }

  return result === undefined ? defaultValue : result;
};
/**
 * Supports '$' prefix or not
 * Used with 'all' tokenPrefix value
 */

var allGet = function allGet(object, path, defaultValue) {
  var result = get(object, path);

  if (typeof path === 'string' && path.startsWith('$')) {
    result = get(object, path.slice(1));
  }

  return result === undefined ? defaultValue : result;
};
var memoizeGet = function memoizeGet(fn) {
  var cache = new WeakMap();

  var memoizedFn = function memoizedFn(obj, path, fallback) {
    if (typeof obj === 'undefined') {
      return fn(obj, path, fallback);
    }

    if (!cache.has(obj)) {
      cache.set(obj, new Map());
    }

    var map = cache.get(obj);

    if (map.has(path)) {
      return map.get(path);
    }

    var value = fn(obj, path, fallback);
    map.set(path, value);
    return value;
  };

  return memoizedFn;
};
var memoizedGet = {
  all: /*#__PURE__*/memoizeGet(allGet),
  prefix: /*#__PURE__*/memoizeGet(prefixGet),
  noprefix: /*#__PURE__*/memoizeGet(get)
};

var defaultTransform = function defaultTransform(_ref) {
  var path = _ref.path,
      object = _ref.object,
      strict = _ref.strict,
      get = _ref.get;
  return get(object, path, strict === true ? undefined : path);
};

var createStyleFunction = function createStyleFunction(_ref2) {
  var properties = _ref2.properties,
      property = _ref2.property,
      scale = _ref2.scale,
      _ref2$transform = _ref2.transform,
      transform = _ref2$transform === void 0 ? defaultTransform : _ref2$transform,
      defaultScale = _ref2.defaultScale,
      tokenPrefix = _ref2.tokenPrefix;

  var _properties = properties || [property];

  if (!tokenPrefix || !['all', 'noprefix', 'prefix'].includes(tokenPrefix)) {
    throw new Error("Invalid tokenPrefix configuration option. Expected \"all\", \"noprefix\" or \"prefix\". Received: " + tokenPrefix);
  }

  var get = memoizedGet[tokenPrefix];

  var systemConfig = function systemConfig(value, scale, props, cache) {
    var result = {};
    var n = value;
    n = transform({
      path: value,
      object: scale,
      props: props,
      strict: cache.strict,
      get: get
    });

    if (n === null) {
      return result;
    }

    _properties.forEach(function (prop) {
      if (prop) {
        result[prop] = n;
      }
    });

    return result;
  };

  Object.assign(systemConfig, {
    scale: scale,
    defaultScale: defaultScale
  });
  return systemConfig;
};

// String.prototype.localeCompare vs Intl.Collator.compare
// https://stackoverflow.com/a/52369951
var collator = /*#__PURE__*/new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base'
}); // Array.sort an object

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return collator.compare(a, b);
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

function mergeObj(a, b) {
  return _extends({}, a, b);
}

var merge = function merge(a, b) {
  var result = mergeObj(a, b);

  for (var key in a) {
    var _mergeObj;

    if (!a[key] || typeof b[key] !== 'object') {
      continue;
    }

    result = mergeObj(result, (_mergeObj = {}, _mergeObj[key] = mergeObj(a[key], b[key]), _mergeObj));
  }

  return result;
};

var pseudoSelectors = {
  _hover: '&:hover',
  _focus: '&:focus',
  _focusWithin: '&:focus-within',
  _focusVisible: '&:focus-visible',
  _active: '&:active',
  _visited: '&:visited',
  _selection: '&::selection',
  _before: '&::before',
  _after: '&::after',
  _placeholder: '&::placeholder',
  _hoverAndFocus: '&:hover, &:focus',
  _disabled: '[disabled], [disabled]:hover, [disabled]:focus, [aria-disabled], [aria-disabled]:hover, [aria-disabled]:focus',
  _readOnly: '[readOnly]',
  _first: '&:first-child',
  _last: '&:last-child',
  _notFirst: '&:not(:first-of-type)',
  _notLast: '&:not(:last-of-type)',
  _checked: '&[aria-checked=true], &[checked]',
  _odd: '&:nth-of-type(odd)',
  _even: '&:nth-of-type(even)'
};

var createMediaQuery$1 = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

function parseBreakpoints(breakpoints) {
  var bps = breakpoints;

  if (!Array.isArray(breakpoints)) {
    bps = Object.values(breakpoints);
  }

  return bps.map(createMediaQuery$1);
}

var createParser = function createParser(config, pseudoSelectors, strict) {
  if (pseudoSelectors === void 0) {
    pseudoSelectors = {};
  }

  if (strict === void 0) {
    strict = false;
  }

  var cache = {
    strict: strict,
    key: '__systemprops__'
  };

  var parse = function parse(props) {
    var _props$theme;

    var styles = {};
    var shouldSort = false; // check cache

    var isCacheBusted = false;

    if (typeof ((_props$theme = props.theme) == null ? void 0 : _props$theme.systemPropsCacheKey) !== 'undefined' && props.theme.systemPropsCacheKey !== cache.key) {
      cache.key = props.theme.systemPropsCacheKey;
      isCacheBusted = true;
    }

    var parseEntry = function parseEntry(obj, key) {
      var systemConfig = config[key];
      var propValue = obj[key];
      var scale = get(props.theme, systemConfig.scale);

      if (typeof propValue === 'function') {
        // e.g.,
        // <Box border={t => `1px solid ${t.colors.primary}`} />
        propValue = propValue(props.theme);
      }

      if (typeof propValue === 'object') {
        var _props$theme2;

        cache.breakpoints = !isCacheBusted && cache.breakpoints || (props == null ? void 0 : (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.breakpoints);

        if (Array.isArray(propValue)) {
          if (typeof cache.breakpoints === 'undefined') {
            throw new Error('The system props parser could not find a `breakpoints` property in the theme object, which is required for responsive styles to work. Make sure that the theme object has a breakpoints property.');
          }

          cache.media = !isCacheBusted && cache.media || [null].concat(parseBreakpoints(cache.breakpoints));
          return parseResponsiveStyle({
            cache: cache,
            systemConfig: systemConfig,
            scale: scale,
            propValue: propValue,
            props: obj
          });
        }

        if (propValue !== null) {
          shouldSort = true;
          return parseResponsiveObject({
            cache: cache,
            systemConfig: systemConfig,
            scale: scale,
            propValue: propValue,
            props: obj
          });
        }
      }

      return systemConfig(propValue, scale, props, cache);
    };

    for (var key in props) {
      // e.g., { _hover: { ... } }
      if (pseudoSelectors[key]) {
        // _hover -> '&:hover'
        var pseudoSelector = pseudoSelectors[key];
        var pseudoStyles = props[key];

        for (var pseudoStyleKey in pseudoStyles) {
          styles[pseudoSelector] = _extends({}, styles[pseudoSelector], parseEntry(pseudoStyles, pseudoStyleKey)); // sort object-based responsive styles

          if (shouldSort) {
            styles[pseudoSelectors[key]] = sort(styles[pseudoSelectors[key]]);
            shouldSort = false;
          }
        }

        continue;
      } // the prop is not a system prop, so bail


      if (!config[key]) {
        continue;
      }

      styles = merge(styles, parseEntry(props, key));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser, _Object$assign;

      Object.assign(parse, (_Object$assign = {}, _Object$assign[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser)), _Object$assign));
    });
  }

  return parse;
};
var createSystem = function createSystem(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$strict = _ref.strict,
      strict = _ref$strict === void 0 ? false : _ref$strict,
      _ref$pseudoSelectors = _ref.pseudoSelectors,
      pseudoSelectors$1 = _ref$pseudoSelectors === void 0 ? pseudoSelectors : _ref$pseudoSelectors,
      _ref$tokenPrefix = _ref.tokenPrefix,
      tokenPrefix = _ref$tokenPrefix === void 0 ? 'prefix' : _ref$tokenPrefix;

  var system = function system(arg) {
    var config = {};
    Object.keys(arg).forEach(function (key) {
      var conf = arg[key];

      if (conf === true) {
        // shortcut definition
        config[key] = createStyleFunction({
          property: key,
          scale: key,
          tokenPrefix: tokenPrefix
        });
        return;
      }

      if (typeof conf === 'function') {
        return;
      }

      config[key] = createStyleFunction(_extends({}, conf, {
        tokenPrefix: tokenPrefix
      }));
    });
    var parser = createParser(config, pseudoSelectors$1, strict);
    return parser;
  };

  return system;
};

var background = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
background.bgImage = background.backgroundImage;
background.bgSize = background.backgroundSize;
background.bgPosition = background.backgroundPosition;
background.bgRepeat = background.backgroundRepeat;

// Full credit goes to modulz/stitches
// Handles complex CSS values and functions like rgba, linear-gradient,
// and other things with parenthesis
// https://github.com/modulz/stitches/blob/1ea8656e849d48b08a9222b89cb919936b0f5f93/packages/core/src/shorthand-parser/value-tokenizer.ts
var TOKEN_STRING = 1;
var TOKEN_QUOTED_STRING = 2;
var TOKEN_FUNCTION = 3;
var TOKEN_BRACKET = 4;
var currentType;
var currentToken = '';
var currentDepth = 0;
var tokenGroups = [[]];
var tokenizeValue = function tokenizeValue(str) {
  resetCurrentToken();
  tokenGroups = [[]];

  if (!str) {
    return tokenGroups;
  }

  var strLength = str.length;

  for (var i = 0; i < strLength; i++) {
    var _char = str[i];

    switch (_char) {
      // whitespace
      case ' ':
        if (currentType === TOKEN_STRING) {
          addCurrentTokenToGroup();
        } else if (currentType) {
          currentToken += _char;
        }

        break;
      // new token group

      case ',':
        if (!currentDepth) {
          addCurrentTokenToGroup();
          addNewTokenGroup();
        } else {
          currentToken += _char;
        }

        break;
      // Quoted string:

      case '"':
        currentToken += _char;

        if (!currentDepth && !currentType) {
          currentType = TOKEN_QUOTED_STRING;
          currentDepth = 1;
        } else if (currentDepth === 1 && currentType === TOKEN_QUOTED_STRING) {
          currentDepth = 0;
          addCurrentTokenToGroup();
        }

        break;
      // Css function:

      case '(':
        if (!currentDepth) currentType = TOKEN_FUNCTION;
        currentDepth++;
        currentToken += _char;
        break;

      case ')':
        currentToken += _char;
        currentDepth--;
        if (currentType === TOKEN_FUNCTION && !currentDepth) addCurrentTokenToGroup();
        break;
      // Bracket values:

      case '[':
        if (!currentDepth) currentType = TOKEN_BRACKET;
        currentToken += _char;
        currentDepth++;
        break;

      case ']':
        currentToken += _char;
        currentDepth--;
        if (!currentDepth) addCurrentTokenToGroup();
        break;

      default:
        if (!currentType) currentType = TOKEN_STRING;
        currentToken += _char;
    }
  }

  if (currentToken) addCurrentTokenToGroup();
  return tokenGroups;
};
/**
 * UTILS:
 */

/**
 * Resets the current token info
 */

function resetCurrentToken() {
  currentDepth = currentType = 0;
  currentToken = '';
}
/**
 * Adds current token to the stack then starts a new one
 */


function addCurrentTokenToGroup() {
  if (currentType) tokenGroups[tokenGroups.length - 1].push(currentToken);
  resetCurrentToken();
}
/**
 * Adds a new token group and requests a new one
 * For things like animations or box shadow where there might be multiple rules
 * applied to the same value
 */


function addNewTokenGroup() {
  tokenGroups[tokenGroups.length] = [];
  resetCurrentToken();
}

var borderShorthandTransform = function borderShorthandTransform(_ref) {
  var _props$theme, _props$theme2, _props$theme3, _props$theme4;

  var path = _ref.path,
      object = _ref.object,
      props = _ref.props,
      strict = _ref.strict,
      get = _ref.get;

  if (typeof path !== 'string') {
    return path;
  }

  var border = get((props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.borders) || object, path);

  if (border) {
    return border;
  }

  var _tokenizeValue = tokenizeValue(path),
      _tokenizeValue$ = _tokenizeValue[0],
      width = _tokenizeValue$[0],
      style = _tokenizeValue$[1],
      color = _tokenizeValue$[2];

  var borderWidth = get(props == null ? void 0 : (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.borderWidths, width, strict ? undefined : width);
  var borderStyle = get(props == null ? void 0 : (_props$theme3 = props.theme) == null ? void 0 : _props$theme3.borderStyles, style, strict ? undefined : style);
  var borderColor = get(props == null ? void 0 : (_props$theme4 = props.theme) == null ? void 0 : _props$theme4.colors, color, strict ? undefined : color);
  return [borderWidth, borderStyle, borderColor].filter(Boolean).join(' ');
};

var config = {
  border: {
    property: 'border',
    scale: 'borders',
    transform: borderShorthandTransform
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders',
    transform: borderShorthandTransform
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders',
    transform: borderShorthandTransform
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders',
    transform: borderShorthandTransform
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders',
    transform: borderShorthandTransform
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders',
    transform: borderShorthandTransform
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders',
    transform: borderShorthandTransform
  }
};
config.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
config.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
config.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
config.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
config.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
config.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
config.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
config.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
config.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
config.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
config.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
config.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
config.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
config.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
config.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
config.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = config;

var color = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  fill: {
    property: 'fill',
    scale: 'colors'
  },
  stroke: {
    property: 'stroke',
    scale: 'colors'
  },
  opacity: true
};
color.bg = color.backgroundColor;
color.textColor = color.color;

var flexContainer = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true
};
var flexItem = {
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = /*#__PURE__*/_extends({}, flexContainer, flexItem);

var gridItem = {
  gridArea: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  justifySelf: true,
  alignSelf: true,
  placeSelf: true
};
var gridContainer = {
  gap: {
    property: 'gap',
    scale: 'space'
  },
  gridGap: {
    property: 'gridGap',
    scale: 'space'
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space'
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space'
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true
};
var grid = /*#__PURE__*/_extends({}, gridItem, gridContainer);

var layout = {
  width: {
    property: 'width',
    scale: 'sizes'
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};

var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var positiveOrNegative = function positiveOrNegative(_ref) {
  var path = _ref.path,
      object = _ref.object,
      strict = _ref.strict,
      get = _ref.get;

  if (!isNumber(path)) {
    if (typeof path === 'string' && path.startsWith('-')) {
      var raw = path.slice(1);

      var _value = get(object, raw, raw);

      if (isNumber(_value)) {
        return _value * -1;
      }

      return "-" + _value;
    }

    return get(object, path, strict ? undefined : path);
  }

  var num = path;
  var isNegative = num < 0;
  var absolute = Math.abs(num);
  var value = get(object, absolute, strict ? undefined : absolute);

  if (isNumber(value)) {
    return value * (isNegative ? -1 : 1);
  }

  if (value == null) {
    return;
  }

  return isNegative ? "-" + value : value;
};

var position = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    transform: positiveOrNegative
  },
  right: {
    property: 'right',
    scale: 'space',
    transform: positiveOrNegative
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    transform: positiveOrNegative
  },
  left: {
    property: 'left',
    scale: 'space',
    transform: positiveOrNegative
  }
};

var getShadow = function getShadow(_ref) {
  var path = _ref.path,
      object = _ref.object,
      get = _ref.get,
      props = _ref.props;
  var result = get(object, path);

  if (result) {
    return result;
  }

  if (typeof path === 'string') {
    return tokenizeValue(path).map(function (chain) {
      return chain.map(function (val) {
        var _props$theme;

        return get(props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.colors, val, val);
      }).join(' ');
    }).join(', ');
  }

  return path;
};

var shadow = {
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows',
    transform: getShadow
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows',
    transform: getShadow
  }
};

var getMargin = function getMargin(_ref) {
  var path = _ref.path,
      object = _ref.object,
      props = _ref.props,
      strict = _ref.strict,
      get = _ref.get;

  // Not using shorthand, just a theme value, e.g, m={4}
  if (typeof path === 'number') {
    var result = positiveOrNegative({
      path: path,
      object: object,
      props: props,
      strict: strict,
      get: get
    });

    if (result) {
      return result;
    }
  }

  if (typeof path === 'string') {
    var arr = path.split(' '); // applied to all sides, return a number or string
    // e.g., m="2" or m="$2"

    if (arr.length === 1) {
      return positiveOrNegative({
        path: path,
        object: object,
        props: props,
        strict: strict,
        get: get
      });
    }

    return arr.reduce(function (acc, curr) {
      var value = positiveOrNegative({
        get: get,
        path: curr,
        object: object,
        props: props,
        strict: strict
      });

      if (typeof value === 'number') {
        // if a number is returned, it's not converted
        // to a pixel value by the css parser in most libraries
        // so we need to make it a string with a pixel value
        value = value + "px";
      }

      return [].concat(acc, [value]);
    }, []).filter(Boolean).join(' ');
  }

  return path;
};

var getPadding = function getPadding(_ref2) {
  var value = _ref2.path,
      object = _ref2.object,
      props = _ref2.props,
      strict = _ref2.strict,
      get = _ref2.get;

  // Not using shorthand, just a theme value, e.g, p={4}
  if (typeof value === 'number') {
    var result = get(object, value);

    if (result) {
      return result;
    }
  }

  if (typeof value === 'string') {
    var arr = value.split(' '); // applied to all sides, return a number or string
    // e.g., m="2" or m="$2"

    if (arr.length === 1) {
      var _props$theme;

      return get(props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.space, value, strict ? undefined : value);
    }

    return value.split(' ').reduce(function (acc, curr) {
      var _props$theme2;

      var value = get(props == null ? void 0 : (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.space, curr, strict ? undefined : curr);

      if (typeof value === 'number') {
        // if a number is returned, it's not converted
        // to a pixel value by the css parser in most libraries
        // so we need to make it a string with a pixel value
        value = value + "px";
      }

      return [].concat(acc, [value]);
    }, []).filter(Boolean).join(' ');
  }

  return value;
};

var margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin
  }
};
margin.m = margin.margin;
margin.mt = margin.marginTop;
margin.mr = margin.marginRight;
margin.mb = margin.marginBottom;
margin.ml = margin.marginLeft;
margin.mx = margin.marginX;
margin.my = margin.marginY;
var padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    transform: getPadding
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    transform: getPadding
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    transform: getPadding
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    transform: getPadding
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    transform: getPadding
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    transform: getPadding
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    transform: getPadding
  }
};
padding.p = padding.padding;
padding.pt = padding.paddingTop;
padding.pr = padding.paddingRight;
padding.pb = padding.paddingBottom;
padding.pl = padding.paddingLeft;
padding.px = padding.paddingX;
padding.py = padding.paddingY;
var space = /*#__PURE__*/_extends({}, padding, margin);

var parseTransition = function parseTransition(_ref) {
  var path = _ref.path,
      object = _ref.object,
      get = _ref.get,
      strict = _ref.strict;
  var result = get(object, path);

  if (result) {
    return result;
  } // '$tokenValue, $anotherTokenValue'
  // '$tokenValue, property duration easing'


  if (typeof path === 'string') {
    var transitions = tokenizeValue(path);
    result = transitions.map(function (transition) {
      if (transition.length === 1) {
        return get(object, transition[0], strict ? undefined : transition[0]);
      }

      return transition.join(' ');
    }).join(', ');
    return result;
  }

  return path;
};

var transition = {
  transition: {
    property: 'transition',
    scale: 'transitions',
    transform: parseTransition
  },
  transitionDuration: {
    property: 'transitionDuration',
    scale: 'transitionDurations'
  },
  transitionTimingFunction: {
    property: 'transitionTimingFunction',
    scale: 'transitionTimingFunctions'
  },
  transitionProperty: true,
  transitionDelay: true
};

var typography = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes'
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};

var isNumber$1 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(_ref) {
  var path = _ref.path,
      object = _ref.object,
      get = _ref.get;
  var defaultValue = path;

  if (isNumber$1(path)) {
    var n = path;
    defaultValue = n > 1 ? path : n * 100 + "%";
  }

  return get(object, path, defaultValue);
};

var layout$1 = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};

var allProps = /*#__PURE__*/_extends({}, pseudoSelectors, background, border, color, grid, flexbox, layout, position, shadow, space, typography);

var propNames = /*#__PURE__*/Object.keys(allProps);

var allPropNames = /*#__PURE__*/new Set(propNames);
var shouldForwardProp = function shouldForwardProp(prop) {
  return !allPropNames.has(prop);
};

export { background, border, color, createSystem, flexContainer, flexItem, flexbox, grid, gridContainer, gridItem, layout, margin, padding, position, propNames, pseudoSelectors, shadow, shouldForwardProp, space, layout$1 as styledSystemLayout, transition, typography };
//# sourceMappingURL=system-props.esm.js.map
